export default __webpack_public_path__ + "static/media/158.c798e256.jpg";